import Utils from "@/modules/core/services/utils";
import { i18n } from '@/plugins/i18next'

export default class EnumService {

  /**
   * Adds additional parameter 'translatedName' which translates enum
   * and sorts array
   *
   * @param data enum array
   * @param translationPath path to the translation
   * @returns {*[]} translated and sorted object array
   */
  static translateAndSortEnum(data, translationPath) {
    let newData = [];
    data.forEach((enumString) => {
      let object = {};
      object.name = enumString;
      object.translatedName = i18n.i18next.t(translationPath + enumString);
      newData.push(object);
    });
    Utils.sort(newData, false, 'translatedName');

    return newData;
  }

  /**
   * Translates and sorts enum object arrays
   *
   * @param data enum object array to translate and sort
   * @param translationPath path to the enum translation
   */
  static translateAndSortEnumObject(data, translationPath) {
    data.forEach((enumObject) => {
      enumObject.translatedName = i18n.i18next.t(translationPath + enumObject.name);
    })
    Utils.sort(data, false, 'translatedName');
  }
}
